import localStorage from 'r/utils/localStorage';
import {FORM_NEW_SIGNAL_DROPDOWN_STATE as localStorageKey} from '../KEYS';

const defaultValue = {
  dropdownScrollPosition: 0,
  collapsedCategories: [],
  inputValue: '',
  isUSD: true,
  isBTC: true,
  isETH: true,
};

const stored = JSON.parse(localStorage.getItem(localStorageKey)) || defaultValue;
export default class FormNewSignalDropdownState {
  static get() {
    return JSON.parse(localStorage.getItem(localStorageKey)) || defaultValue;
  }

  static set(value) {
    Object.assign(stored, value);
    localStorage.setItem(localStorageKey, JSON.stringify(stored));
  }
}
